/**
 * The catalogs the Automatic workspace shows before a file is identified.
 *
 * They are a shop window, not a source of truth: until /ecu/check answers,
 * nothing is known about which solutions apply, so the full list renders inert
 * to say what the service can do. The moment a check comes back, the grids are
 * built from its response alone and these lists are not consulted again — so a
 * name missing here can never hide a solution the engine actually offers.
 */
export const SOLUTION_MODULES = [
  "DPF",
  "EGR",
  "Adblue",
  "LAMBDA",
  "FLAPS (Swirl)",
  "Active Grill Shutter",
  "Boost Sensor Calibration",
  "CAT/KAT",
  "Cylinder On Demand OFF",
  "EVAP",
  "Exhaust Valve OFF",
  "Glow Plug",
  "GPF/OPF",
  "Hotstart",
  "Immo Off (EPROM)",
  "Immo Off (FLASH)",
  "Immo Off (Flash+MCUID)",
  "Immo Virgin - EPROM",
  "MAF",
  "NOX",
  "Oil Pressure Fix",
  "Readiness Calibration",
  "RPM Soft Limiter Removal",
  "SAP",
  "Sport Displays Calibration",
  "Start-Stop",
  "Torque Monitor",
  "TPROT",
  "TVA",
  "VMAX",
  "Water Pump",
];

/**
 * The canonical tuning names, same idea as SOLUTION_MODULES: the check only
 * returns the tunings that qualify for the uploaded file, so the full list is
 * rendered and the check decides which ones can be switched on.
 */
export const TUNING_STAGES = [
  "Stage1",
  "Stage1+",
  "Stage2",
  "Eco Tune",
  "Pops&Bangs",
  "Pops&Bangs (Switchable)",
  "Launch Control Activation",
  "HardCut",
  "E85 Conversion",
  "FCA Unlock",
];
